/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from "react";
import ReleasesTable from "./ReleasesTable";

export default function SignedApproval() {
  return (
    <>
      <ReleasesTable
        filterBy="Approval Released"
        approval_status="Approval Released"
        title="Signed Approvals"
        query_type="director"
        return_status="Approval Initiated Returned"
        showHistoryTab={true}
      />
    </>
  );
}
